import 'picturefill';

import cookieConsent from './cookieConsent';
import videolink from './videolink';
import { NavToggle, StickyHeader } from './headerActions';
import { HeroSlider } from './sliders';
import renderGoogleMap from './renderGoogleMap';
import { ProductSearch } from './productSearch';
import contactForm from './contactForm';
import stickProductImage from './productStickyImage';
import limitLines from './limitLines';

const jQuery = require('jquery');

global.jQuery = jQuery;

const APP = {};

APP.init = function () {
    cookieConsent();
    videolink();

    // contact form
    contactForm();

    window.initMap = renderGoogleMap;


    this.navToggle = new NavToggle(jQuery('.header__nav-trigger'));
    this.navToggle.init();

    this.stickyHeader = new StickyHeader(jQuery('.header'));
    this.stickyHeader.init();

    this.heroSlider = new HeroSlider(jQuery('.hero__slider'));
    this.heroSlider.init();

    this.productSearch = new ProductSearch(jQuery('.filter-form'));
    this.productSearch.init();

    stickProductImage();

    document.addEventListener('readystatechange', (event) => {
        if (event.target.readyState === 'complete') {
            jQuery('.product-list__excerpt a').each((index, element) => {
                limitLines(jQuery(element)[0], 3);
            });
        }
    });
};
document.addEventListener('DOMContentLoaded', APP.init);
